import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import "../index.css"

// utils
import { round } from '../../../utils';

// Inputs
import { CheckboxField, Button, TextInputField } from '../../../helpers'

// redux
import { raiseToast } from '../../../services/redux/reducers/toast/toast';



const DNBuyerInvoiceItems = (props) => {

    const dispatch = useDispatch()

    const {
        buyerInvoiceItem,
        selectedBuyerInvoiceItemIds,
        buyerInvoiceItemsPIPunch,
        rejectedReasonName,
    } = props

    const handleUnitPriceAndQtyChange = (event, selectedBuyerInvoiceItemId, selectedReplacedBuyerInvoiceItemId, isReplacedItem) => {
        //const relatedBuyerInvoiceItem = buyerInvoiceItemsPIPunch.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerInvoiceItemId == isReplacedItem ? selectedReplacedBuyerInvoiceItemId : selectedBuyerInvoiceItemId)

        const relatedBuyerInvoiceItem = buyerInvoiceItemsPIPunch.find(eachBuyerInvoiceItem => {
            if(isReplacedItem){
                if(eachBuyerInvoiceItem.replacedBuyerInvoiceItemId === selectedReplacedBuyerInvoiceItemId){
                    return eachBuyerInvoiceItem
                }
            }else{
                if(eachBuyerInvoiceItem.buyerInvoiceItemId === selectedBuyerInvoiceItemId){
                    return eachBuyerInvoiceItem
                }
            }
        })

        if (relatedBuyerInvoiceItem) {
            const regex = /^\d*\.?\d{0,3}$/;

            if (!regex.test(event.target.value)) {
                return dispatch(raiseToast({ severity: 'warn', detail: `Only 3 decimal values are allowed`, life: 3000 }))
            }

            if (event.target.name === "debitNoteProductQuantity") {
                relatedBuyerInvoiceItem["debitNoteProductQuantity"] = event.target.value
                    if(relatedBuyerInvoiceItem.isReplaced){
                        relatedBuyerInvoiceItem?.replacedBuyerInvoiceItems?.map(eachReplacedBuyerInvoiceItem => {
                            let relatedMaterialReplacedQty = relatedBuyerInvoiceItem?.toReplace[eachReplacedBuyerInvoiceItem?.materialId]
                            if(relatedMaterialReplacedQty){
                                eachReplacedBuyerInvoiceItem.debitNoteProductQuantity = round(parseFloat(relatedBuyerInvoiceItem.debitNoteProductQuantity) * relatedMaterialReplacedQty)
                            }
                        })
                    }
                    /*
                if (relatedBuyerInvoiceItem.availableDebitNoteQty >= event.target.value) {
                    relatedBuyerInvoiceItem["debitNoteProductQuantity"] = event.target.value
                    if(relatedBuyerInvoiceItem.isReplaced){
                        relatedBuyerInvoiceItem?.replacedBuyerInvoiceItems?.map(eachReplacedBuyerInvoiceItem => {
                            let relatedMaterialReplacedQty = relatedBuyerInvoiceItem?.toReplace[eachReplacedBuyerInvoiceItem?.materialId]
                            if(relatedMaterialReplacedQty){
                                eachReplacedBuyerInvoiceItem.debitNoteProductQuantity = round(parseFloat(relatedBuyerInvoiceItem.debitNoteProductQuantity) * relatedMaterialReplacedQty)
                            }
                        })
                    }
                }
                else {
                    relatedBuyerInvoiceItem["debitNoteProductQuantity"] = 0
                    if(relatedBuyerInvoiceItem.isReplaced || relatedBuyerInvoiceItem.companyQtyMultiplier){
                        relatedBuyerInvoiceItem?.replacedBuyerInvoiceItems?.map(eachReplacedBuyerInvoiceItem => {
                            eachReplacedBuyerInvoiceItem.debitNoteProductQuantity = 0
                        })
                    }
                    return dispatch(raiseToast({ severity: 'warn', detail: `Only ${relatedBuyerInvoiceItem.availableDebitNoteQty} quantity available`, life: 3000 }))
                }
                */
            }

            if (event.target.name === "debitNoteUnitPrice") {
                /*
                if (event.target.value >= relatedBuyerInvoiceItem.unitPrice) {
                    return dispatch(raiseToast({ severity: 'warn', detail: `Debit Note price should not be more than or equal to invoice price ${relatedBuyerInvoiceItem.unitPrice}`, life: 3000 }))
                }
                */
                relatedBuyerInvoiceItem["debitNoteUnitPrice"] = event.target.value
            }
        }

        props.setBuyerInvoiceItemsPIPunch([...buyerInvoiceItemsPIPunch])
    }

    return (
        <div className='sellerpo-items-list'>
            {
                buyerInvoiceItem ?
                    <div className='mb-2'>
                        <div className='grid ml-2'>
                            <div className='flex flex-row col-12 md:col-12 lg:col-12 pb-0 justify-content-between'>
                                <div className='flex flex-row col-12 md:col-4 lg:col-4 align-items-center'>
                                    <CheckboxField
                                        name={'buyerInvoiceItemId'}
                                        checked={selectedBuyerInvoiceItemIds?.includes(buyerInvoiceItem.isReplaced ? buyerInvoiceItem.replacedBuyerInvoiceItemId : buyerInvoiceItem.buyerInvoiceItemId)}
                                        onChange={(event) => props.handleSelectBuyerInvoiceItem(event, buyerInvoiceItem.isReplaced ? buyerInvoiceItem.replacedBuyerInvoiceItemId : buyerInvoiceItem.buyerInvoiceItemId)}
                                        disabled={rejectedReasonName === "ReInvoicing"}
                                    />
                                    <p className='ml-2 my-0'><span style={{ fontWeight: 700, fontSize: '13px' }}>{buyerInvoiceItem.productName} | {buyerInvoiceItem.productSpecification}</span></p>
                                </div>
                                <div className='flex flex-wrap col-12 md:col-2 lg:col-2 h-3rem ml-4'>
                                    <TextInputField
                                        name="debitNoteProductQuantity"
                                        placeholder="Enter qty"
                                        keyfilter="pnum"
                                        value={buyerInvoiceItem?.debitNoteProductQuantity}
                                        onChange={(event) => handleUnitPriceAndQtyChange(event, buyerInvoiceItem?.buyerInvoiceItemId, buyerInvoiceItem?.replacedBuyerInvoiceItemId, buyerInvoiceItem?.isReplaced)}
                                        disabled={rejectedReasonName === "ReInvoicing"}
                                    />
                                </div>
                                <div className="flex flex-row col-12 md:col-3 lg:col-2 w-10rem align-items-center h-3rem">
                                    (Available Qty: <span>{buyerInvoiceItem?.availableDebitNoteQty}</span>)
                                </div>
                                <div className='flex flex-row col-12 md:col-2 lg:col-2 h-3rem align-items-center'>
                                    <label style={{ color: "#343840", fontSize: "13px" }} className='ml-2 mr-2'>
                                        Price:
                                    </label>
                                    <TextInputField
                                        name="debitNoteUnitPrice"
                                        placeholder="Enter UnitPrice"
                                        label={"Unit Price"}
                                        keyfilter="pnum"
                                        value={buyerInvoiceItem?.debitNoteUnitPrice}
                                        onChange={(event) => handleUnitPriceAndQtyChange(event, buyerInvoiceItem?.buyerInvoiceItemId, buyerInvoiceItem?.replacedBuyerInvoiceItemId, buyerInvoiceItem?.isReplaced)}
                                    />
                                </div>
                                <div className="flex flex-row col-12 md:col-3 lg:col-2 align-items-center h-3rem">
                                    (Actual Price: <span>{buyerInvoiceItem?.unitPrice}</span>)
                                </div>
                            </div>
                        </div>
                        {
                            (buyerInvoiceItem.isReplaced && buyerInvoiceItem?.toReplace) ?
                                buyerInvoiceItem?.replacedBuyerInvoiceItems?.map(eachReplacedBuyerInvoiceItem => {
                                    return (
                                        <div className='mb-2'>
                                            <div className='grid ml-2'>
                                                <div className='flex flex-row col-12 md:col-12 lg:col-12 pb-0 justify-content-between'>
                                                    <div className='flex flex-row col-12 md:col-4 lg:col-4 align-items-center'>
                                                        <p className='ml-5 my-0'><span style={{ fontWeight: 400, fontSize: '13px' }}>{eachReplacedBuyerInvoiceItem?.productName} | {eachReplacedBuyerInvoiceItem?.productSpecification}</span></p>
                                                    </div>
                                                    <div className='flex flex-wrap col-12 md:col-2 lg:col-2 h-3rem ml-4'>
                                                        <TextInputField
                                                            name="debitNoteProductQuantity"
                                                            placeholder="Enter qty"
                                                            keyfilter="pnum"
                                                            value={eachReplacedBuyerInvoiceItem?.debitNoteProductQuantity}
                                                            onChange={(event) => handleUnitPriceAndQtyChange(event, buyerInvoiceItem?.buyerInvoiceItemId, eachReplacedBuyerInvoiceItem?.buyerInvoiceItemId, buyerInvoiceItem?.isReplaced )}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="flex flex-row col-12 md:col-3 lg:col-2 w-10rem align-items-center h-3rem">
                                                        {/* (Available Qty: <span>{eachReplacedBuyerInvoiceItem?.availableDebitNoteQty}</span>) */}
                                                    </div>
                                                    <div className='flex flex-row col-12 md:col-2 lg:col-2 h-3rem align-items-center'>
                                                        {/* <label style={{ color: "#343840", fontSize: "13px" }} className='ml-2 mr-2'>
                                                            Price:
                                                        </label>
                                                        <TextInputField
                                                            name="debitNoteUnitPrice"
                                                            placeholder="Enter UnitPrice"
                                                            label={"Unit Price"}
                                                            keyfilter="pnum"
                                                            value={eachReplacedBuyerInvoiceItem?.debitNoteUnitPrice}
                                                            onChange={(event) => handleUnitPriceAndQtyChange(event, buyerInvoiceItem?.buyerInvoiceItemId, eachReplacedBuyerInvoiceItem?.buyerInvoiceItemId, buyerInvoiceItem?.isReplaced)}
                                                            disabled={rejectedReasonName !== "Price Adjustment"}
                                                        /> */}
                                                    </div>
                                                    <div className="flex flex-row col-12 md:col-3 lg:col-2 align-items-center h-3rem">
                                                        {/* (Actual Price: <span>{eachReplacedBuyerInvoiceItem?.unitPrice}</span>) */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                : ""
                        }
                    </div>
                    : ""
            }
            <div className="hr-line"></div>
        </div>
    )
}

export default DNBuyerInvoiceItems